import { createSlice } from "@reduxjs/toolkit";
import {
  fetchOrganisationById,
  fetchOrganisations,
  updateOrganisation,
  updateStatusInOrg,
  fetchAllDropdowns,
  exportOrganisationsCSV,
} from "./thunk";

interface OrganisationState {
  organisationsList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedOrganisation: any;
  orgDropDown: any[];
  industryTypeDropDown: any[];
  orgCityDropDown: any[];
  orgStateDropDown: any[];
  pincodeDropDown: any[];
  exportCSVLoading: boolean;
  exportCSVError: string | null;
  countryDropDown: any[]; // ✅ fixed
}

const initialState: OrganisationState = {
  organisationsList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  orgDropDown: [],
  industryTypeDropDown: [],
  orgCityDropDown: [],
  orgStateDropDown: [],
  pincodeDropDown: [],
  countryDropDown: [], // ✅ now matches the corrected type
  exportCSVLoading: false,
  exportCSVError: null,
};


const organisationSlice = createSlice({
  name: "organisations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch All Organisations
      .addCase(fetchOrganisations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrganisations.fulfilled, (state, action) => {
        state.loading = false;
        state.organisationsList = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
        state.rowCount =
          typeof action.payload.rowCount === "number"
            ? action.payload.rowCount
            : 0;
      })
      .addCase(fetchOrganisations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch organisations";
      })

      // Fetch Single Organisation by ID
      .addCase(fetchOrganisationById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrganisationById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedOrganisation = action.payload;
      })
      .addCase(fetchOrganisationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Organisation
      .addCase(updateOrganisation.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.organisationsList = state.organisationsList.map((org) =>
          org.organization_id === action.payload.organization_id ? action.payload : org
        );
      })
      .addCase(updateOrganisation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update organisation";
      })

      // Update Status
      .addCase(updateStatusInOrg.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.organisationsList = state.organisationsList.map((org) =>
          org.id === action.payload.id ? action.payload : org
        );
      })
      // .addCase(updateStatusInOrg.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error =
      //     action.error.message || "Failed to update organisation status";
      // });
    builder
      .addCase(fetchAllDropdowns.fulfilled, (state, action) => {
        state.orgDropDown = action.payload.orgDropDown || [];
        state.industryTypeDropDown = action.payload.industryTypeDropDown || [];
        state.orgCityDropDown = action.payload.orgCityDropDown || [];
        state.orgStateDropDown = action.payload.orgStateDropDown || [];
        state.pincodeDropDown = action.payload.pincodeDropDown || [];
        state.countryDropDown = action.payload.countryDropDown || [];
         
        
      })
      .addCase(exportOrganisationsCSV.pending, (state) => {
        state.exportCSVLoading = true;
        state.exportCSVError = null;
      })
      .addCase(exportOrganisationsCSV.fulfilled, (state) => {
        state.exportCSVLoading = false;
        state.exportCSVError = null;
      })
      .addCase(exportOrganisationsCSV.rejected, (state, action) => {
        state.exportCSVLoading = false;
        state.exportCSVError =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Failed to export CSV";
      });
  },
});

export default organisationSlice.reducer;
